export default __webpack_public_path__ + "static/media/arrow_left.b10e6c87.svg";